import { render } from "./gsrbr0204.vue?vue&type=template&id=8f25d19e&scoped=true"
import script from "./gsrbr0204.vue?vue&type=script&lang=js"
export * from "./gsrbr0204.vue?vue&type=script&lang=js"

import "./gsrbr0204.vue?vue&type=style&index=0&id=8f25d19e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f25d19e"]])

export default __exports__